import { useEffect, useRef } from "react";

/**
 * Renders lines with a clip-path stagger animation.
 * lines: array of strings; each is revealed with cumulative 80ms delay.
 */
export default function HeroStagger({ lines, delay = 100, className = "" }) {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    const els = container.querySelectorAll(".hero-line");
    const timers = [];
    els.forEach((el, i) => {
      const t = setTimeout(() => el.classList.add("is-in"), delay + i * 80);
      timers.push(t);
    });
    return () => timers.forEach(clearTimeout);
  }, [delay]);

  return (
    <div ref={containerRef} className={className}>
      {lines.map((line, i) => (
        <div className="hero-line" key={i}>
          <span>{line}</span>
        </div>
      ))}
    </div>
  );
}
